import React from 'react';
import * as PropTypes from 'prop-types';
import AssignmentIcon from '@material-ui/icons/Assignment';
import IconButton from './IconButton';
import { SubjectPropType } from '../../abilities/proptypes';

const QuestionnaireIconButton = ({ onClick, color, size, disabled, subject, action }) => (
    <IconButton
        onClick={onClick}
        color={color}
        size={size}
        disabled={disabled}
        subject={subject}
        action={action}
    >
        <AssignmentIcon />
    </IconButton>
);

QuestionnaireIconButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    size: PropTypes.string,
    color: PropTypes.string,
    disabled: PropTypes.bool,
    action: PropTypes.string,
    subject: SubjectPropType,
};

QuestionnaireIconButton.defaultProps = {
    size: null,
    color: undefined,
    disabled: false,
    subject: null,
    action: null,
};

export default QuestionnaireIconButton;
